export function getLoggedInLoadingMessages(t: (key: string, options?: any) => string, key: string | undefined): { title: string; description: string } {
  if (!key) {
    return {
      title: '',
      description: t('summary:loggingIn'),
    }
  }
  return {
    title: t(`common:${key}:title`, { defaultValue: '' }),
    description: t(`common:${key}:description`),
  }
}
